import * as React from 'react';
import { Component } from 'react';
import { Field, Form, reduxForm, getFormValues } from 'redux-form';
import { enableAutosave } from '../../redux/actions/general/autosave';
import styles from '../../styles/forms/my_company_members/UserEmploymentTermsForm.scss';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';
import {
  __,
  convertMinutesToHours,
  mapStateToProps,
  redirect,
  setTableParams,
} from '../../core/utils';
import * as _ from 'lodash';
import classNames from 'classnames';
import Input from '../../components/Input';
import Select from '../../components/Select';
import { listCompanySegments } from '../../redux/actions/table/company_segments';
import { listCompanyPositions } from '../../redux/actions/table/company_positions';
import { listPossibleWorkSites } from '../../redux/actions/table/timesheets';
import { map } from 'lodash';
import EditIcon from '../../assets/images/edit-16x16.svg';
import Tooltip from '../../components/Tooltip';
import {
  readCompanyMemberEmploymentTermsDaysData,
  readCompanyMemberEmploymentTermsGeneralData,
  readCompanyMemberEmploymentTermsTimeOffData,
} from '../../redux/actions/table/my_company_members';
import { dateFrom } from '../../core/utils';

@reduxForm({
  form: 'my_company_members.user_employment_terms',
  enableReinitialize: true,
})
@withRouter
@mapStateToProps((state) => ({
  table: state.table['my_company_members'],
  user_id: state.auth.id,
  values: getFormValues('my_company_members.user_employment_terms')(state),
}))
@subscribe(Localization, 'localization')
class UserEmploymentTermsForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      possible_offices: [],
      possible_segments: [],
      possible_positions: [],
    };
  }

  componentDidMount() {
    listPossibleWorkSites().then(({ response }) => {
      this.setState({ possible_offices: response.data });
    });

    listCompanySegments().then(({ response }) => {
      this.setState({
        possible_segments: response.data.map((item) => ({
          value: item.id,
          label: item.name,
        })),
      });
    });

    listCompanyPositions().then(({ response }) => {
      this.setState({
        possible_positions: response.data.map((item) => ({
          value: item.id,
          label: item.name,
        })),
      });
    });
  }

  UNSAFE_componentWillReceiveProps() {
    enableAutosave(this.props.form);
  }

  render() {
    const { data, user_id, initialValues } = this.props;
    const { possible_offices, possible_segments, possible_positions } =
      this.state;

    const {
      general_changed_fields,
      days_changed_fields,
      time_off_changed_fields,
      general_future,
      days_future,
      time_off_future,
    } = initialValues;

    const workplaces = [
      { label: __('home'), value: 'home' },
      { label: __('office'), value: 'office' },
      { label: __('partial'), value: 'partial' },
    ];

    const type_of_employments = [
      { label: __('employee'), value: 'employee' },
      { label: __('external'), value: 'external' },
    ];

    const logs_time_options = [
      { value: 'true', label: __('Yes') },
      { value: 'false', label: __('No') },
    ];

    const isChangedGeneralField = (fieldName) => {
      return general_changed_fields?.[fieldName] === true;
    };

    const isChangedDaysField = (fieldName) => {
      return days_changed_fields?.[fieldName] === true;
    };

    const isChangedTimeOffField = (fieldName) => {
      return time_off_changed_fields?.[fieldName] === true;
    };

    const getGeneralFutureTooltip = (fieldName) => {
      if (general_future && general_future[fieldName] != null) {
        const formattedDate = dateFrom(
          general_future?.general_start_date,
          true
        );

        return `NEXT CHANGE: ${formattedDate}\nNEW VALUE: ${general_future[fieldName]}`;
      }
      return null;
    };

    const getDaysFutureTooltip = (fieldName) => {
      if (days_future && days_future[fieldName] != null) {
        const formattedDate = dateFrom(days_future?.hours_start_date, true);
        const convertedValue = convertMinutesToHours(days_future[fieldName]);

        return `NEXT CHANGE: ${formattedDate}\nNEW VALUE: ${convertedValue}`;
      }
      return null;
    };

    const getTimeOffFutureTooltip = (fieldName) => {
      if (time_off_future && time_off_future[fieldName] != null) {
        const formattedDate = dateFrom(
          time_off_future?.time_off_start_date,
          true
        );

        const convertedValue = fieldName.includes("minutes")
          ? convertMinutesToHours(time_off_future[fieldName])
          : time_off_future[fieldName];

        return `NEXT CHANGE: ${formattedDate}\nNEW VALUE: ${convertedValue}`;
      }

      return null;
    };

    return (
      <Form onSubmit={this.props.handleSubmit}>
        <div className={styles.form}>
          <div className={classNames(styles.flex, styles.groupTitleRow)}>
            <div className={styles.f1}>
              <label className={styles.label}>
                {__('my-company-members.flyout.employment_details_title')}
              </label>
            </div>
            <div className={classNames(styles.edit, styles.groupTitleEdit)}>
              <Tooltip
                text={__(
                  'my-company-members.flyout.edit-employment-details-group'
                )}
              >
                <EditIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    readCompanyMemberEmploymentTermsGeneralData(
                      this.props.initialValues.user_id
                    ).then(({ response }) => {
                      setTableParams('my_company_members', {
                        edit_my_company_member_employment_general_group_wizard: true,
                        employmentGeneralData: response,
                      });
                    });
                  }}
                />
              </Tooltip>
            </div>
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='address_book_company_id'
                searchable={true}
                component={Select}
                orangeArrow={isChangedGeneralField('address_book_company_id')}
                orangeArrowTooltip={getGeneralFutureTooltip(
                  'address_book_company_name'
                )}
                label={__('my_company_members.flyout.office')}
                options={map(possible_offices, (office) => ({
                  value: office.id,
                  label: office.name,
                }))}
                // callbackSetNewValue={(value) => {
                //   createNewWorksite(value);
                // }}
                placeholder={__('my_company_members.flyout.select-office')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='company_segment_id'
                searchable={true}
                component={Select}
                orangeArrow={isChangedGeneralField('company_segment_id')}
                orangeArrowTooltip={getGeneralFutureTooltip(
                  'company_segment_name'
                )}
                label={__('table.columns.office_segment')}
                options={possible_segments}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='work_place'
                component={Select}
                orangeArrow={isChangedGeneralField('work_place')}
                orangeArrowTooltip={getGeneralFutureTooltip('work_place')}
                searchable={true}
                label={__('table.columns.workplace')}
                options={workplaces}
              />
            </div>
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='company_position_id'
                searchable={true}
                component={Select}
                orangeArrow={isChangedGeneralField('company_position_id')}
                orangeArrowTooltip={getGeneralFutureTooltip(
                  'company_position_name'
                )}
                label={__('table.columns.office_position')}
                options={possible_positions}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='type'
                component={Select}
                orangeArrow={isChangedGeneralField('type')}
                orangeArrowTooltip={getGeneralFutureTooltip('type')}
                searchable={true}
                label={__('table.columns.type_of_employment')}
                options={type_of_employments}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='logs_time'
                component={Select}
                orangeArrow={isChangedGeneralField('logs_time')}
                orangeArrowTooltip={getGeneralFutureTooltip('logs_time')}
                searchable={true}
                label={__('table.columns.logs_time')}
                options={logs_time_options}
              />
            </div>
          </div>

          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='prior_work_experience'
                component={Input}
                orangeArrow={isChangedGeneralField('prior_work_experience')}
                orangeArrowTooltip={getGeneralFutureTooltip(
                  'prior_work_experience'
                )}
                label={__('my_company_members.flyout.prior_work_experience')}
                placeholder='YY-MM-DD'
                numeric
                options={{
                  delimiter: '-',
                  blocks: [2, 2, 2],
                  numericOnly: true,
                }}
                hint={'YY-MM-DD'}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='company_employment_date'
                component={Input}
                orangeArrow={isChangedGeneralField('company_employment_date')}
                orangeArrowTooltip={getGeneralFutureTooltip(
                  'company_employment_date'
                )}
                label={__('my_company_members.flyout.company_employment_date')}
                placeholder='DD.MM.YYYY'
                numeric
                options={{
                  delimiter: '.',
                  blocks: [2, 2, 4],
                  numericOnly: true,
                }}
                hint={'DD.MM.YYYY'}
              />
            </div>
            <div className={styles.f1}></div>
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='company_work_experience'
                component={Input}
                // orangeArrow={isChangedGeneralField('company_work_experience')}
                label={__('my_company_members.flyout.company_work_experience')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='total_work_experience'
                component={Input}
                // orangeArrow={isChangedGeneralField('total_work_experience')}
                label={__('my_company_members.flyout.total_work_experience')}
              />
            </div>
            <div className={styles.f1}></div>
          </div>

          <div className={styles.dividerLine} />
          <div className={classNames(styles.flex, styles.groupTitleRow)}>
            <div className={styles.f1}>
              <label className={styles.label}>
                {__('my-company-members.flyout.working-hours-title')}
              </label>
            </div>
            <div className={classNames(styles.edit, styles.groupTitleEdit)}>
              <Tooltip
                text={__('my-company-members.flyout.edit-working-hours-group')}
              >
                <EditIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    readCompanyMemberEmploymentTermsDaysData(
                      this.props.initialValues.user_id
                    ).then(({ response }) => {
                      setTableParams('my_company_members', {
                        edit_my_company_member_employment_days_group_wizard: true,
                        employmentDaysData: response,
                      });
                    });
                  }}
                />
              </Tooltip>
            </div>
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='monday_minutes'
                component={Input}
                orangeArrow={isChangedDaysField('monday_minutes')}
                orangeArrowTooltip={getDaysFutureTooltip('monday_minutes')}
                label={__('table.columns.monday_minutes')}
                hint={__('table.columns.hint.in-hours')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='tuesday_minutes'
                component={Input}
                orangeArrow={isChangedDaysField('tuesday_minutes')}
                orangeArrowTooltip={getDaysFutureTooltip('tuesday_minutes')}
                label={__('table.columns.tuesday_minutes')}
                hint={__('table.columns.hint.in-hours')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='wednesday_minutes'
                component={Input}
                orangeArrow={isChangedDaysField('wednesday_minutes')}
                orangeArrowTooltip={getDaysFutureTooltip('wednesday_minutes')}
                label={__('table.columns.wednesday_minutes')}
                hint={__('table.columns.hint.in-hours')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='thursday_minutes'
                component={Input}
                orangeArrow={isChangedDaysField('thursday_minutes')}
                orangeArrowTooltip={getDaysFutureTooltip('thursday_minutes')}
                label={__('table.columns.thursday_minutes')}
                hint={__('table.columns.hint.in-hours')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='friday_minutes'
                component={Input}
                orangeArrow={isChangedDaysField('friday_minutes')}
                orangeArrowTooltip={getDaysFutureTooltip('friday_minutes')}
                label={__('table.columns.friday_minutes')}
                hint={__('table.columns.hint.in-hours')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='saturday_minutes'
                component={Input}
                orangeArrow={isChangedDaysField('saturday_minutes')}
                orangeArrowTooltip={getDaysFutureTooltip('saturday_minutes')}
                label={__('table.columns.saturday_minutes')}
                hint={__('table.columns.hint.in-hours')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='sunday_minutes'
                component={Input}
                orangeArrow={isChangedDaysField('sunday_minutes')}
                orangeArrowTooltip={getDaysFutureTooltip('sunday_minutes')}
                label={__('table.columns.sunday_minutes')}
                hint={__('table.columns.hint.in-hours')}
              />
            </div>
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='weekly_hours'
                component={Input}
                // orangeArrow={isChangedDaysField('weekly_hours')}
                label={__('table.columns.weekly_hours')}
              />
            </div>
            <div className={styles.f1}></div>
            <div className={styles.f1}></div>
            <div className={styles.f1}></div>
            <div className={styles.f1}></div>
            <div className={styles.f1}></div>
            <div className={styles.f1}></div>
          </div>

          {/* <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='total_working_hours'
                component={Input}
                label={__('table.columns.total_working_hours')}
              />
            </div>

            <div className={styles.f3} />
          </div> */}

          <div className={styles.dividerLine} />
          <div className={classNames(styles.flex, styles.groupTitleRow)}>
            <div className={styles.f1}>
              <label className={styles.label}>
                {__('my-company-members.flyout.time-off-title')}
              </label>
            </div>
            <div className={classNames(styles.edit, styles.groupTitleEdit)}>
              <Tooltip
                text={__('my-company-members.flyout.edit-time-off-group')}
              >
                <EditIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    readCompanyMemberEmploymentTermsTimeOffData(
                      this.props.initialValues.user_id
                    ).then(({ response }) => {
                      setTableParams('my_company_members', {
                        edit_my_company_member_employment_time_off_group_wizard: true,
                        employmentTimeOffData: response,
                      });
                    });
                  }}
                />
              </Tooltip>
            </div>
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='vacation_days_base'
                component={Input}
                orangeArrow={isChangedTimeOffField('vacation_days_base')}
                orangeArrowTooltip={getTimeOffFutureTooltip(
                  'vacation_days_base'
                )}
                label={__('table.columns.vacation_days_base')}
              />
            </div>

            <div className={styles.f1}>
              <Field
                disabled={true}
                name='minutes_off_base'
                component={Input}
                orangeArrow={isChangedTimeOffField('minutes_off_base')}
                orangeArrowTooltip={getTimeOffFutureTooltip('minutes_off_base')}
                label={__('table.columns.max_compensatory_hours')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='last_year_vacation_days'
                component={Input}
                orangeArrow={isChangedTimeOffField('last_year_vacation_days')}
                orangeArrowTooltip={getTimeOffFutureTooltip(
                  'last_year_vacation_days'
                )}
                label={__('table.columns.last_year_vacation_days')}
              />
            </div>
          </div>

          {/* <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='overtime_substitution' // removed ?
                component={Input}
                label={__('table.columns.overtime_substitution')}
              />
            </div>
            <div className={styles.f1} />
          </div> */}

          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='used_vacation_days'
                component={Input}
                orangeArrow={isChangedTimeOffField('used_vacation_days')}
                orangeArrowTooltip={getTimeOffFutureTooltip(
                  'used_vacation_days'
                )}
                label={__('table.columns.used_vacation_days')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='used_minutes_off'
                component={Input}
                orangeArrow={isChangedTimeOffField('used_minutes_off')}
                orangeArrowTooltip={getTimeOffFutureTooltip('used_minutes_off')}
                label={__('table.columns.compensatory_hours_used')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='vacation_days_remaining'
                component={Input}
                orangeArrow={isChangedTimeOffField('vacation_days_remaining')}
                orangeArrowTooltip={getTimeOffFutureTooltip(
                  'vacation_days_remaining'
                )}
                label={__('table.columns.vacation_days_remaining')}
              />
            </div>
          </div>

          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='available_compensatory_hours'
                component={Input}
                orangeArrow={isChangedTimeOffField('minutes_off_remaining')}
                orangeArrowTooltip={getTimeOffFutureTooltip(
                  'minutes_off_remaining'
                )}
                label={__('table.columns.available_compensatory_hours')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='working_days'
                component={Input}
                // orangeArrow={isChangedTimeOffField('working_days')}
                label={__('table.columns.working_days')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='sick_days'
                component={Input}
                // orangeArrow={isChangedTimeOffField('sick_days')}
                label={__('table.columns.sick_days')}
              />
            </div>
          </div>

          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='working_hours'
                component={Input}
                // orangeArrow={isChangedTimeOffField('working_hours')}
                label={__('table.columns.working_hours')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='overtime_hours'
                component={Input}
                // orangeArrow={isChangedTimeOffField('overtime_hours')}
                label={__('table.columns.overtime_hours')}
              />
            </div>
            <div className={styles.f1} />
          </div>
          <div className={styles.dividerLine} />

          <div className={classNames(styles.flex, styles.links)}>
            <div>
              <span>{__('my_timesheet')}</span>
              <span
                onClick={() => {
                  const url = `/timesheets?filter.user=${this.props.data?.user_id}`;
                  redirect(url);
                }}
              >
                {__('link')}
              </span>
            </div>
          </div>
          <div className={classNames(styles.flex, styles.links)}>
            <div>
              <span>{__('days_off_record')}</span>
              <span
                onClick={() => {
                  const url = `/timesheets?filter.user=${this.props.data?.user_id}&filter.leave_reason=4`;
                  redirect(url);
                }}
              >
                {__('link')}
              </span>
            </div>
          </div>
          <div className={classNames(styles.flex, styles.links)}>
            <div>
              <span>{__('vacation_record')}</span>
              <span
                onClick={() => {
                  const url = `/timesheets?filter.user=${this.props.data?.user_id}&filter.leave_reason=1`;
                  redirect(url);
                }}
              >
                {__('link')}
              </span>
            </div>
          </div>
          <div className={classNames(styles.flex, styles.links)}>
            <div>
              <span>{__('sick_leave_record')}</span>
              <span
                onClick={() => {
                  const url = `/timesheets?filter.user=${this.props.data?.user_id}&filter.leave_reason=2`;
                  redirect(url);
                }}
              >
                {__('link')}
              </span>
            </div>
          </div>
        </div>
      </Form>
    );
  }
}

export default UserEmploymentTermsForm;
